import axios from "axios";
import { getLocationOrigin } from "../../utils/util.js";

/* 重置密码函数 */
export const resetPasswordFunction = async (props) => {
    let {
        phone,
        captcha,
        password
    } = props;
    try {
        const data = {
            phone,
            verify_code: captcha,
            new_password: password,
        }
        const baseURL = `${process.env.REACT_APP_BASE_URL || window.location.origin}/api/`
        const res = await axios.put(`${baseURL}sys/password/retrieve/`, data);
        let success = res.data.code === 0;
        return {
            success,
            msg: res.data.msg,
        };
    } catch (error) {
        return {
            success: false,
            msg: error.message,
        };
    }
}

/* 账号密码登录 */
export const passwordLoginFunction = async (props) => {
    let {
        username,
        password
    } = props;
    try {
        const data = {
            phone: username,
            password,
        }
        const baseURL = `${process.env.REACT_APP_BASE_URL || window.location.origin}/api/`
        const res = await axios.post(`${baseURL}sys/login/`, data);
        let success = res.data.code === 0;
        return {
            success,
            msg: res.data.msg,
            ticket: res.data?.data?.ticket,
        };
    } catch (error) {
        return {
            success: false,
            msg: error.message,
        };
    }
}

/* 手机号登录 */
export const phoneLoginFunction = async (props) => {
    let {
        phone,
        captcha
    } = props;
    try {
        const data = {
            phone,
            verify_code: captcha,
        }
        const baseURL = `${process.env.REACT_APP_BASE_URL || window.location.origin}/api/`
        const res = await axios.post(`${baseURL}sys/login/`, data);
        let success = res.data.code === 0;
        return {
            success,
            msg: res.data.msg,
            ticket: res.data?.data?.ticket,
        };
    } catch (error) {
        return {
            success: false,
            msg: error.message,
        };
    }
}

/* 跳转函数 - 与 SaasLogin.loginFunc 保持一致，统一走 /loading 处理 ticket 换 token 与菜单权限校验
 * ticket: 登录 ticket 字符串（可选）
 * explicitRedirect: 显式传入的 redirect 目标；不传则从当前 URL 的 ?redirect= 解析
 */
export const redirectFunction = (ticket, explicitRedirect) => {
    let href = getLocationOrigin() + '/loading';

    if (ticket) {
        href = href + '?ticket=' + ticket;
    }

    let decodedRedirect = explicitRedirect;
    if (!decodedRedirect) {
        try {
            const url = window.location.href;
            const params = new URLSearchParams(url.split('?')[1] || '');
            const rawRedirect = params.get('redirect') || '';
            decodedRedirect = decodeURIComponent(rawRedirect);
        } catch (error) {
            console.error('跳转链接解析失败:', error);
        }
    }

    if (decodedRedirect) {
        href = href + (ticket ? '&' : '?') + 'redirect=' + encodeURIComponent(decodedRedirect);
    }

    window.location.href = href;
};
